import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { ImageCroppingPresets, useMediaAsset } from '../../../modules/Media/MediaUtils';
import { SmartContainer } from '../../../styles/Containers';
import { StyledIconButton } from '../../../styles/matieralui/IconButton';
import { StyledCircularProgress } from '../../../styles/matieralui/Progress';
import { StyledA } from '../../../styles/StyledHTML';
import { IconCheck, IconDownload } from '../../Icons';
import { downloadFileUrl } from '../../services/CaptureCollabService';

const StyledSmallProgress = styled(StyledCircularProgress)`
    width: 25px !important;
    height: 25px !important;
    opacity: 0.5;
`


export const AssetDownloadButton = ({ asset }) => {

    const [view, setView] = useState('rest');
    const [download, setDownload] = useState(null)
    const [downloadName, setDownloadName] = useState(null);
    const { assetLoading, assetPath, assetSrc, setMediaId, activeMedia } = useMediaAsset({ network: false, args: {} });


    const loadImageData = async (path) => {
        const blob = await fetch(path).then(r => r.blob());
        return blob;
    }


    const handleClick = async (e) => {
        e.stopPropagation()
        // if (view === 'rest') {
        //     setMediaId(asset?.meta?.MediaId);
        //     setView('downloading');
        // }
        // if (view === 'done') {
        //     setView('rest')
        // }

        // TODO: BRING BACK SHARE API
        // Open And Download
        // if (navigator.share) {
        //     setView('downloading');
        //     const blob = await loadImageData(assetSrc);


        //     console.log(blob, "B")
        //     const shareObj = {
        //         files: [
        //             new File([blob], asset.name + '.jpg', {
        //                 type: 'image/jpg',
        //             }),
        //         ],
        //         // title: asset?.name,
        //         // text: "",
        //     };

        //     try {
        //         if (!(navigator.canShare(shareObj))) {
        //             throw new Error("Can't share data.", shareObj);
        //         }
        //         setView('rest')
        //         await navigator.share(shareObj);
        //     } catch (err) {
        //         setView('rest')

        //         if (err.message.indexOf('cancel') > -1) {
        //             setView('rest');
        //         } else {
        //             window.location.href = assetSrc; // Reload. Sharing has stopped working.
        //         }

        //     }

        // } else {
        //     // fallback
        //     window.open(assetSrc)
        // }

        // OPEn
        // window.open(assetSrc)

        // Load then Download
        setMediaId(asset?.meta?.MediaId);

    }


    useEffect(() => {
        if (!asset) return;
        // setMediaId(asset?.meta?.MediaId);
    }, [asset])



    useEffect(() => {

        if (!assetSrc) return;
        // const p = assetSrc.split('?');
        // const nP = p[0].split('/');
        // const name = nP[nP.length - 1];
        // setDownload(p[0]);
        // setDownloadName(name);

        setTimeout(() => window.open(assetSrc, '_top'), 100);
    }, [assetSrc])

    return (

        <StyledIconButton onClick={handleClick}>
            {view === 'rest' && (<IconDownload />)}
            {view === 'downloading' && (<StyledSmallProgress />)}
            {view === 'done' && (<IconCheck />)}

        </StyledIconButton>

    )
    // return (

    //     <StyledA href={assetSrc} download target="_blank"><IconDownload /></StyledA>

    // )
}